import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["diagram"]

  async connect() {
    window.mermaid.initialize({ startOnLoad: false, securityLevel: "loose" })
    await window.mermaid.init(undefined, [this.diagramTarget])

    if (this.data.get("interactive") !== "true") return

    const svg = this.diagramTarget.querySelector("svg")
    const { x, y, width, height } = svg.getBBox()
    svg.setAttribute("viewBox", `${x} ${y} ${width} ${height}`)
    svg.setAttribute("height", "100%")

    this.panZoom = window.svgPanZoom(svg, {
      zoomEnabled: true,
      panEnabled: true,
      controlIconsEnabled: false,
      fit: true,
      center: true,
      minZoom: 0.5,
      maxZoom: 8
    })

    this.resizeObserver = new ResizeObserver(() => this.panZoom.resize())
    this.resizeObserver.observe(this.diagramTarget)
    this.element.classList.add("flowchart-ready")
  }

  panUp() {
    this.panZoom.panBy({ x: 0, y: 50 })
  }

  panLeft() {
    this.panZoom.panBy({ x: 50, y: 0 })
  }

  panRight() {
    this.panZoom.panBy({ x: -50, y: 0 })
  }

  panDown() {
    this.panZoom.panBy({ x: 0, y: -50 })
  }

  reset() {
    this.panZoom.reset()
    this.panZoom.fit()
    this.panZoom.center()
  }

  zoomIn() {
    this.panZoom.zoomIn()
  }

  zoomOut() {
    this.panZoom.zoomOut()
  }

  disconnect() {
    this.resizeObserver?.disconnect()
    this.panZoom?.destroy()
  }
}
